import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import { Select } from 'ui/styled';
var generateHeightOptions = function () {
    var options = [];
    for (var feet = 1; feet <= 8; feet++) {
        for (var inches = 0; inches < 12; inches++) {
            options.push({
                value: "".concat(feet, "'").concat(inches, "\u2033"),
                label: "".concat(feet, "'").concat(inches, "\u2033")
            });
        }
    }
    return options;
};
var Height = function (_a) {
    var onInputChange = _a.onInputChange, id = _a.id;
    var options = generateHeightOptions();
    return (_jsx(Form.Item, { name: id, label: "Height", children: _jsx(Select, { options: options, onChange: onInputChange, placeholder: "Select height", style: { width: 200 }, "data-test": "heightSelect", showSearch: true }) }));
};
export default Height;
